import fetch from "auth/FetchInterceptor";

const RoleModuleService = {};
const BASE_URL = "/role-modules";

RoleModuleService.fetch = (roleId) =>
    fetch({
        url: `${BASE_URL}/${roleId}/modules`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

RoleModuleService.attachModule = (roleModule) =>
    fetch({
        url: `${BASE_URL}/attach`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: roleModule
    });

RoleModuleService.fetchRolePermissions = (module) =>
    fetch({
        url: `${BASE_URL}/permissions`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: {
            module
        }
    });
export default RoleModuleService;